import { AuthProvider } from "./AuthContext/AuthContext";

import { combineComponents } from "../utils/combineComponents";

const providers = [AuthProvider];

export const AuthContextProvider = combineComponents(...providers);
